export const CATEGORY_OPTIONS = [
  "Starlight Yoga",
  "Galaxy Beats",
  "Star Power Affirmations",
  "Gentle Nebula Sounds",
  "Cosmic Journeys",
];

export const CATEGORY_ALIASES = {
  "Starlight Yoga": ["Starlight Yoga", "Yoga", "Yuga"],
  "Galaxy Beats": ["Galaxy Beats", "Binaural Beats"],
  "Star Power Affirmations": ["Star Power Affirmations", "Daily Affirmations"],
  "Gentle Nebula Sounds": ["Gentle Nebula Sounds", "ASMR"],
  "Cosmic Journeys": ["Cosmic Journeys", "Guided Meditations"],
};

export function matchesCategory(videoCategory, selectedCategory) {
  if (selectedCategory === "All Category") return true;
  const aliases = CATEGORY_ALIASES[selectedCategory];
  return aliases ? aliases.includes(videoCategory) : videoCategory === selectedCategory;
}

/** Map a stored DB category to the canonical option for dropdowns. */
export function resolveCanonicalCategory(storedCategory) {
  if (!storedCategory) return CATEGORY_OPTIONS[0];
  for (const [canonical, aliases] of Object.entries(CATEGORY_ALIASES)) {
    if (aliases.includes(storedCategory)) return canonical;
  }
  if (CATEGORY_OPTIONS.includes(storedCategory)) return storedCategory;
  return storedCategory;
}
